module.exports = __webpack_public_path__ + "html/multi-share_05ce42ebf563f400b84c8f61e4027e04.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/publish/multi-share.html
// module id = 8ReI
// module chunks = 51